import { render, staticRenderFns } from "./activeForm.vue?vue&type=template&id=55549342&scoped=true&"
import script from "./activeForm.vue?vue&type=script&lang=js&"
export * from "./activeForm.vue?vue&type=script&lang=js&"
import style0 from "./activeForm.vue?vue&type=style&index=0&id=55549342&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55549342",
  null
  
)

export default component.exports